import React from 'react';
import { Item } from './styles';
import { formatValue, formatTimestamp, formatDuration, getActiveErrors, SystemError, GB } from './utils';

export default function Status({ data }) {
  if (!data) return null;

  return (
    <Item>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {d.signal_percentage && `Signal strength: ${formatValue(d.signal_percentage, 0)}% `}
          {d.signal_operator && <>({d.signal_operator})</>}<br />
          {d.data_rate && <>Data rate: {formatValue(d.data_rate, 0)} Hz<br /></>}
          {d.disk_usage_free && <>Free disk space: {formatValue(d.disk_usage_free / GB)} GB<br /></>}
          {d.cpu_temperature && <>CPU temperature: {formatValue(d.cpu_temperature, 0)} °C<br /></>}
          {d.cpu_load && <>CPU load: {formatValue(d.cpu_load, 0)}%<br /></>}
          {d.uptime !== undefined && <>Uptime: {formatDuration(d.uptime)}<br /></>}
          {d.camera_module_on !== undefined && <>Camera module: {d.camera_module_on ? 'on' : 'off'}<br /></>}
          {d.ais_on !== undefined && <>AIS charger: {d.ais_on ? 'on' : 'off'}<br /></>}
          {d.pressure && <>Pressure: {formatValue(d.pressure / 1000, 2)} bar<br /></>}
          {d.temperature && <>Temperature: {formatValue(d.temperature)} °C<br /></>}
          {d.timestamp && formatTimestamp(d.timestamp)}<br />
          {d.state && <><br />{d.state}</>}
          {d.errors !== undefined && d.errors !== SystemError.ERROR_NONE && <div><br />{getActiveErrors(SystemError, d.errors)?.join(', ')}</div>}
        </div>
      ))}
    </Item>
  );
}
